/* =============================================
   OLFACTUM — Drawer Cart JS
   Exposes Alpine component for drawer-cart.liquid
   ============================================= */

document.addEventListener('alpine:init', () => {

  Alpine.data('drawerCart', () => ({
    get cart() {
      return Alpine.store('cart');
    },

    get items() {
      return this.cart.items;
    },

    get isEmpty() {
      return this.cart.totalQuantity === 0;
    },

    async increment(item) {
      if (item.quantity >= 10) {
        Alpine.store('toast').show('Máximo 10 unidades por producto.');
        return;
      }
      await this.cart.updateItem(item.key, item.quantity + 1);
    },

    async decrement(item) {
      if (item.quantity <= 1) {
        await this.cart.removeItem(item.key);
      } else {
        await this.cart.updateItem(item.key, item.quantity - 1);
      }
    },

    async remove(item) {
      await this.cart.removeItem(item.key);
    },

    trapFocus(e) {
      const drawer = this.$refs.drawer;
      if (!drawer) return;
      const focusable = [...drawer.querySelectorAll(
        'button:not([disabled]), a[href], input, textarea, select, [tabindex]:not([tabindex="-1"])'
      )];
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    },

    checkout() {
      if (this.cart.totalQuantity === 0) return;
      if (typeof window.fbq === 'function') {
        try {
          fbq('track', 'InitiateCheckout', {
            value: this.cart.totalPrice / 100,
            currency: 'MXN',
            num_items: this.cart.totalQuantity,
            content_ids: (this.cart.items || []).map(function (i) { return String(i.product_id); }),
            content_type: 'product'
          });
        } catch (_) { /* noop */ }
      }
      window.location.href = '/checkout';
    }
  }));

});
